module.exports = __webpack_public_path__ + "assets/calendar.75c9247867694e117bcc5aa8381e33da.svg";